import { createContext } from "react";

  export const AppContext = createContext<{
    locale:string,
    setLocale:(locale:string)=>void
  }|null>(null);
